module.exports = {
  branch_name: '滨海店',
  system_name: '青柠檬宿综合管理系统',
  website_title: ' - 青柠檬宿综合管理系统(滨海店)',
  startup_date: '2019-01-01T00:00:00.000+0000',
  branches: [{
    name: '车立方店',
    url: 'https://apt1.wzxm.site/',
  }, {
    name: '滨海店',
    url: 'https://apt2.wzxm.site/',
  }, {
    name: '柠檬宿酒店',
    url: 'https://apt3.wzxm.site/',
  }, {
    name: '欧文酵室',
    url: 'https://apt4.wzxm.site/',
  }],
  logic: {
    manual_meter: true,
  },
  constants: {
    utilities: {
      price: {
        electricity: 1,
      },
    },
  },
}



// WEBPACK FOOTER //
// ./config.override.js